<template>
  <Pagination v-if="meta" :meta="meta" :on-change-page="onChangePage"/>
</template>

<script>
import Pagination from "../../components/dashboard/Pagination.vue";

export default {
  name: "Pagination-400",
  components: {Pagination},
  props: ['meta', 'onChangePage'],
}
</script>
